// extracted by mini-css-extract-plugin
export default {"wordPopup":"WordPopupVisual_wordPopup__1NtHy"};